import { Button } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface CancelButtonProps {
  onClick: () => void;
  disabled?: boolean;
  sx?: object;
}

const CancelButton = ({ onClick, disabled = false, sx }: CancelButtonProps) => {
  return (
    <Button
      type="button"
      disabled={disabled}
      onClick={onClick}
      sx={{
        textTransform: "none",
        padding: "12px 20px",
        borderRadius: "8px",
        alignItems: "center",
        justifyContent: "center",
        width: "120px",
        color: nawyTheme.nawy.colors.semantic.text.accent,
        backgroundColor: nawyTheme.nawy.colors.semantic.layer.primary,
        border: `1px solid ${nawyTheme.nawy.colors.semantic.layer.accent}`,
        ...muiTheme.typography.h4_med,
        "&:hover": {
          backgroundColor: "#F9FAFB",
          border: `1px solid ${nawyTheme.nawy.colors.semantic.layer.accent}`,
        },
        "&:active": {
          backgroundColor: "#F2F4F7",
        },
        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
        ...sx,
      }}
    >
      Cancel
    </Button>
  );
};

export default CancelButton;
